import { gql } from '@apollo/client';

export const UPDATE_ACCOUNT_LANGUAGE = gql`
  mutation UpdateAccountLanguage($language: String) {
    updateAccountLanguage(language: $language)
  }
`;

